import {
  MaterialOrderPermissionsProvider,
  StockPage,
  StorageLevelsRouteProvider
} from '@features/storage-levels'
import {TourBanner} from '@hconnect/uikit/src/lib2'
import {useUpmPlantContext} from '@hconnect/upm'
import React from 'react'

import {useStockMaterialOrderPermissions} from '../../shared/permissions/useStockMaterialOrderPermissions'

export const PageStock: React.FC = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  const permissions = useStockMaterialOrderPermissions()
  return (
    <StorageLevelsRouteProvider
      pathGenerators={{
        getStockPath: (subPath) => `/plants/${plantCode}/stock/${subPath}`,
        getMaterialsPath: () => `/plants/${plantCode}/stock/materials`,
        getSilosPath: () => `/plants/${plantCode}/stock/silos`
      }}
    >
      <MaterialOrderPermissionsProvider permissions={permissions}>
        <TourBanner sx={{mt: 3, mx: {xs: 2, lg: 6}}} />
        <StockPage plantId={plantCode} />
      </MaterialOrderPermissionsProvider>
    </StorageLevelsRouteProvider>
  )
}
